import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';

import { ServiceWorkerConfigService } from '../../../service-worker/service-worker-config.service';
import { ServiceWorkerState, ServiceWorkerStateService } from '../../../service-worker/service-worker-state.service';
import { KnownInstrumentationEvents } from '../../instrumentation/instrumentation.service';
import { FetchStrategy, InstrumentedHttp, InstrumentedHttpDataResponse } from '../../instrumentation/instrumented-http.service';
import { HttpResponseContentType } from '../../models/http-response-content-type.enum';
import { ObservableHelper } from '../../utilities/observable-helper.utility';

@Pipe({ name: 'urlCachePipe' })
export class UrlCachePipe implements PipeTransform {

    public constructor(
        private readonly instrumentedHttp: InstrumentedHttp,
        private readonly domSanitizer: DomSanitizer,
        private readonly serviceWorkerStateService: ServiceWorkerStateService,
        private readonly serviceWorkerConfigService: ServiceWorkerConfigService) {
    }

    public transform(url: string): Observable<SafeUrl> {
        return ObservableHelper.createResultsWithCacheObservable(
            this.getData(url, FetchStrategy.CacheOnly),
            this.getData(url, FetchStrategy.NetworkFirst)
        ).results;
    }

    private async getData(url: string, networkStrategy: FetchStrategy): Promise<any> {
        // Todo: If there is more than one serviceworker match function that uses a header to match insteads of a regex, it might be better to use
        // an interceptor to intercept the calls and remove the custom headers if the service worker is not enabled.
        const res: InstrumentedHttpDataResponse<{}> = await this.instrumentedHttp.get(KnownInstrumentationEvents.ThumbnailCachePipeLoad, url, {
            headers: this.serviceWorkerStateService.currentState === ServiceWorkerState.Controlled && this.serviceWorkerConfigService.config.enabled ?
                new Map([['X-SW-OHP-ThumbnailCacheable', 'ODSP_THUMBNAIL_CACHEABLE']]) : null,
            responseType: HttpResponseContentType.Blob
        },
            networkStrategy);
        const blobUrl = URL.createObjectURL(res.data);
        // eslint-disable-next-line @microsoft/sdl/no-angular-bypass-sanitizer
        return this.domSanitizer.bypassSecurityTrustUrl(blobUrl);
    }
}
